import { Table, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutRevenueCodeLookup } from "./autogen/AutogenLayoutRevenueCodeLookup";

export class RevenueCodeLookup extends AutogenLayoutRevenueCodeLookup {

    override async onLoad(): Promise<void> {
        const tableRevenueCodeLookup: Table = this.tableRevenueCodeLookup;
        tableRevenueCodeLookup.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            if (tableRow.index > 0) {
                tableRow.table.rows[tableRow.index - 1].borderBottomWidth = 1;
            }
        });
    }
}
